
import { Component, ElementRef, OnDestroy, OnInit, ViewChild, ChangeDetectorRef } from '@angular/core';
import { Subject, Subscription } from 'rxjs';
import { CustomerModel } from '../../../../models/customer.model';
import { Store } from '@ngrx/store';
import * as fromApp from '../../../../store/app.reducer';
import { MatSnackBar } from '@angular/material/snack-bar';
import { createData } from '../create-object';
import * as AssignmentsActions from '../../store/assignments.actions';
import { UtilityOptionModel } from '../../../../models/utilityOption.model';
import { UniformModel } from '../../../../models/uniform.model';
import { SkillModel } from '../../../../models/skill.model';
import * as SharedActions from '../../../../shared-store/shared.actions';
import { filter, take, takeUntil } from 'rxjs/operators';
import { TranslateService } from '@ngx-translate/core';

@Component({
    selector: 'app-step2',
    templateUrl: './step2.component.html',
    styleUrls: ['./step2.component.scss'],
    standalone: false
})
export class Step2Component implements OnInit, OnDestroy {
    public choose = false;
    public editOptionsModal: boolean = false;
    public competenceModal: boolean = false;
    public clothingModal: boolean = false;
    public chosenCategory: number;
    public chosenOptions: number[] = [];
    public subscription: Subscription;
    public customer: CustomerModel;
    public uniforms: UniformModel[] = [];
    public selectedUniform: UniformModel;
    public selectedSkill: SkillModel;
    public utilityOptions: UtilityOptionModel[] = [];
    public selectedUtilityOptions: UtilityOptionModel[] = [];
    public skills: SkillModel[] = [];
    isCreatingAssignmentFromHistory: boolean;
    public firstLoad = true;
    unsubscribe$: Subject<void> = new Subject<void>();
    showBottomSheet: Boolean = false;
    show = false;
    public currentLang: string;
    @ViewChild('uniformOptions') uniformOptions!: ElementRef;

    constructor(private store: Store<fromApp.AppState>,
        private _snackBar: MatSnackBar,
        private translateService: TranslateService,
        private cd: ChangeDetectorRef) {
        this.currentLang = this.translateService.currentLang;
        this.translateService.onLangChange.pipe(
            takeUntil(this.unsubscribe$)
        ).subscribe(event => {
            this.currentLang = event.lang;
        });
    }

    ngOnInit(): void {
        this.subscription = this.store.subscribe((appState: any) => {
            this.customer = appState?.auth?.customer || null;
        });
        this.chosenCategory = createData.assignmentCategoryId;
        this.store.dispatch(new SharedActions.LoadSkills({ customerId: this.customer.id }));
        if (this.chosenCategory == 5 && createData.skillId) {
            this.store.dispatch(new SharedActions.LoadSkillUniforms({
                skillId: createData.skillId,
            }));
        }
        this.store.select(state => state.shared.skills)
            .pipe(
                takeUntil(this.unsubscribe$),
                filter(x => x.length > 0),
                take(1)
            )
            .subscribe(skills => {
                this.skills = skills;

                this.selectedSkill = createData.skillId
                    ? this.skills.find(x => x.id == createData.skillId)
                    : this.skills[0];

                createData.skillId = this.selectedSkill.id;

                // Dispatch API for default skill
                this.store.dispatch(new AssignmentsActions.LoadPreviousAssignment({
                    assignment_category_id: createData.assignmentCategoryId,
                    skill_id: createData.skillId
                }));

                this.store.dispatch(new SharedActions.LoadSkillUniforms({
                    skillId: createData.skillId,
                }));
            });

        this.store.select(state => state.shared.uniforms)
            .pipe(
                takeUntil(this.unsubscribe$),
                // filter(x => x.length > 0)
            )
            .subscribe(uniforms => {
                this.uniforms = uniforms;

                if (this.uniforms.length > 0) {
                    this.selectedUniform = createData.uniformId
                        ? this.uniforms.find(x => x.id == createData.uniformId)
                        : { id: 0, name: '', imagePath: '' };

                    // createData.uniformId = this.selectedUniform.id;
                } else {
                    createData.uniformId = undefined;
                    this.selectedUniform = null;
                }
            });
        this.store.select(state => state.assignments.previousAssignments)
            .pipe(
                filter(data => !!data?.hasPreviousAssignments && data.data?.length > 0),
                take(1)
            )
            .subscribe(data => {
                // Set jobPlaceId for use in Step 3
                createData.jobPlaceId = data.data[0].jobPlace?.id;
            });
    }

    ngOnDestroy() {
        this.unsubscribe$.unsubscribe();
    }

    public onRemoveOption(option: UtilityOptionModel): void {
        let index = this.chosenOptions.indexOf(option.id);
        let index2 = this.selectedUtilityOptions.indexOf(option);
        this.chosenOptions.splice(index, 1);
        this.selectedUtilityOptions.splice(index2, 1);
    }

    onSelectedCompetence(skill: SkillModel): void {
        this.selectedSkill = skill;
        this.competenceModal = false;
        createData.skillId = skill.id;
        createData.uniformId = undefined;
        createData.utilityOptionIds = undefined;
        this.selectedUniform = null;
        this.selectedUtilityOptions = [];
        this.choose = false;

        this.store.dispatch(new AssignmentsActions.LoadPreviousAssignment({
            assignment_category_id: createData.assignmentCategoryId,
            skill_id: skill.id
        }));

        if (this.chosenCategory == 5) {
            this.selectedUniform = null;
            this.selectedUtilityOptions = [];
            createData.uniformId = undefined;
            createData.utilityOptionIds = [];
        }

        this.store.dispatch(new SharedActions.LoadSkillUniforms({
            skillId: skill.id,
        }));
    }

    onSelectedUniform(uniform: UniformModel): void {
        this.selectedUniform = uniform;
        this.clothingModal = false;
        createData.uniformId = uniform.id;
    }

    public onSaveAndContinue(): void {
        if (!createData.skillId) {
            this._snackBar.open('Please select competence.', 'Close', {
                duration: 3000,
                panelClass: ['snackbar'],
            });
            return;
        }
        this.showBottomSheet = false;
        this.store.dispatch(new AssignmentsActions.UpdateStep(null));

        if (this.isCreatingAssignmentFromHistory) {
            this.store.dispatch(new AssignmentsActions.UpdateStep(7));
        } else {
            this.store.dispatch(new AssignmentsActions.UpdateStep(3));
        }
    }

    trackByUniform(index: number, item: any): string | number {
        return item?.id || index;
    }

    getTruncatedName(name: string | undefined | null): string {
        if (!name) return '';
        return name.length > 30 ? name.slice(0, 30) + '...' : name;
    }
}